import React from 'react';
import { MediaStream } from '../interfaces/interface';
interface MediaContext {
  audio: {
    encode: boolean;
    decode: boolean;
  };
  video: {
    encode: boolean;
    decode: boolean;
  };
  mediaStream: MediaStream | null;
}
export default React.createContext({} as MediaContext);
